import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as S from './styles';
export const FormContainer = ({ name, children }) => {
    return (_jsxs(S.Form, { children: [_jsx(S.Name, { children: name }), children] }));
};
